import { render } from "./ConfigurationTable.vue?vue&type=template&id=2d906d06&scoped=true"
import script from "./ConfigurationTable.vue?vue&type=script&lang=js"
export * from "./ConfigurationTable.vue?vue&type=script&lang=js"

import "./ConfigurationTable.vue?vue&type=style&index=0&id=2d906d06&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d906d06"]])

export default __exports__